import React, { useMemo, useState, useRef } from 'react';
import LabelManageResultStyled from './LabelManageResultStyled';
import {
  useTheme,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'dva';
import { TextFieldCom } from '../../../label_manage/components/FormType';

/**
 * 描述
 * @author 刑天
 * @date 2021-12-28
 * @param {any} list
 * @param {any} id
 * @returns {any}
 */
const getParentId = (list, id) => {
  for (let i in list) {
    if (list[i].id === id) {
      return [list[i]];
    }
    if (list[i].children) {
      let node = getParentId(list[i].children, id);
      if (node !== undefined) {
        return node.concat(list[i]);
      }
    }
  }
};

const LabelManageResult = (props) => {
  const {
    tagId,
    labelDirectoryList = [],
    setIsEdit,
    isEdit,
    setInitExpandedKeys,
    setTreeValue,
  } = props;
  const subRef = useRef();
  const saveRef = useRef();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [sOpen, setSOpen] = useState(false);
  const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
    defaultValues: {},
  });

  const tagName = useMemo(() => {
    if (labelDirectoryList && labelDirectoryList.length > 0 && tagId) {
      const arr = getParentId(labelDirectoryList, tagId)?.reverse();
      if (arr) {
        setValue('name', arr[arr.length - 1].name);
        clearErrors();
        //新增
        if (isEdit) {
          setValue('name', '');
          return arr.map((item) => item.name).join('/');
        } else if (!isEdit && arr.length > 1) {
          const newArr = [...arr];
          const sArr = newArr.splice(0, newArr.length - 1);
          return sArr.map((item) => item.name).join('/');
        }
      }
    }
    return '';
  }, [labelDirectoryList, tagId, setValue, clearErrors, isEdit]);

  const theme = useTheme();

  //查询
  // eslint-disable-next-line no-unused-vars
  const handleSubmitSuccess = (submitData) => {
    const arr = getParentId(labelDirectoryList, tagId)?.reverse() || [];
    const id = arr.length > 0 ? arr[arr.length - 1].id : null;
    const pid = arr.length > 0 ? arr[arr.length - 1].pid : 0;
    let newPid = '';
    if (isEdit) {
      newPid = id;
    } else {
      newPid = pid;
    }
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { id: isEdit ? null : id, pid: newPid, name: submitData.name }, // 事件公参
    });
    dispatch({
      type: 'labelManage/postInsertOrUpdate',
      payload: {
        values: {
          id: isEdit ? null : id,
          pid: newPid,
          name: submitData.name,
        },
      },
      callback: () => {
        setSOpen(false);
        window.message.toast({
          type: 'success',
          message: '保存成功',
        });
        const ids = arr.map((item) => item.id);
        isEdit && setInitExpandedKeys(ids);
      },
    });
  };

  /**
   * 描述:点击删除弹出诶确认
   * @author 刑天
   * @date 2021-12-29
   * @returns {any}
   */
  const handleDelete = () => {
    setOpen(true);
  };

  /**
   * 描述:点击删除二次确认的取消或者x
   * @author 刑天
   * @date 2021-12-29
   * @returns {any}
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * 描述:点击删除二次确认的确定按钮
   * @author 刑天
   * @date 2021-12-29
   * @returns {any}
   */
  const handleCloseSureTip = () => {
    setOpen(false);
    const arr = getParentId(labelDirectoryList, tagId)?.reverse() || [];
    dispatch({
      type: 'labelManage/postDeleteTagCatalogue',
      payload: {
        values: {
          tagId,
        },
      },
      callback: () => {
        window.message.toast({
          type: 'success',
          message: '删除成功',
        });
        setTreeValue();
        const ids = arr.map((item) => item.id);
        setInitExpandedKeys(ids);
      },
    });
  };

  /**
   * 描述:点击保存按钮
   * @author 刑天
   * @date 2021-12-31
   * @returns {any}
   */
  const handleOpenSub = () => {
    setSOpen(true);
  };

  /**
   * 描述:取消保存
   * @author 刑天
   * @date 2021-12-31
   * @returns {any}
   */
  const handleCloseSub = () => {
    setSOpen(false);
  };

  /**
   * 描述:点击确认保存
   * @author 刑天
   * @date 2021-12-31
   * @returns {any}
   */
  const handleCloseSureTipSub = () => {
    subRef.current.click();
  };

  /**
   * 描述：触发表单的error
   * @author 刑天
   * @date 2021-12-31
   * @returns {any}
   */
  const handleSubmitErrors = () => {
    setSOpen(false);
  };
  return (
    <LabelManageResultStyled theme={theme}>
      <Box className="result-content-top">
        <div className="content-top-left">
          <span className="top-bcg"></span>
          <div className="top-content-wrap">
            <span className="tooltip-wrap">{tagName}</span>
            <div className="content-bottom-list"></div>
          </div>
        </div>
      </Box>
      <div className="result-list-wrap">
        <form
          onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitErrors)}
          style={{ height: '100%' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Box width="312px" mt={3}>
              <TextFieldCom
                autoFocus={false} //If true, the input element is focused during the first mount.
                initLabel={true} //自定义的label是否显示
                showLabel={false} //是否需要显示label
                placeholder="请输入标签目录"
                helperText="" //用于校验的提醒文字
                name="name"
                label={isEdit ? '添加子目录' : '编辑目录'} //label
                control={control}
                errors={errors}
                setValue={setValue}
                isNumber={false}
                isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                isParseInt={false} //true 只能输入正整数，false可以输入小数
                showError={true} //false输入框捕获到错误不展示错误样式，默认true
                rules={{
                  required: true, //是否是必填项true 必填 false 非必填
                  maxLength: 20,
                }}
                initHeight={{ height: 'auto' }}
              />
              <Box mt={4}>
                {!isEdit && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{
                      width: '138px',
                      borderRadius: '24px',
                      height: '34px',
                    }}
                    onClick={() => {
                      setIsEdit(true);
                      setValue('name', '');
                    }}
                  >
                    添加子目录
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              pl={0}
              mt={0.5}
              mb={0.5}
              className="button-wrap"
            >
              <Button
                variant="contained"
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
                sx={{ marginRight: '16px' }}
                onClick={handleOpenSub}
              >
                保存
              </Button>
              {!isEdit && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_tag_directory_list_delete',
                    events: ['_ev', '_ec'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  variant="contained"
                  color="secondary"
                  className="cancel"
                  startIcon={
                    <CloseIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={() => handleDelete()}
                >
                  删除
                </Button>
              )}
            </Box>
          </Box>
          <Button ref={subRef} type="submit" sx={{ display: 'none' }}></Button>
        </form>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ width: '200px' }}
          >
            您确认删除吗？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={handleClose}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleCloseSureTip}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={sOpen}
        onClose={handleCloseSub}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ width: '200px' }}
          >
            您确认保存吗？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={handleCloseSub}
          >
            取消
          </Button>
          <Button
            ref={saveRef}
            data-log={JSON.stringify({
              oid: 'btn_user_profile_tag_directory_list_save',
              events: ['_ev'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
              mountParentSelector: '#label_id_mount_parent',
            })}
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleCloseSureTipSub}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </LabelManageResultStyled>
  );
};

export default LabelManageResult;
